// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../factories/translate-dialog";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import TranslateDialog from "../factories/translate-dialog";
class LanguageConfigurationItem extends BaseViewModel {
    Name1: KnockoutObservable<string> = ko.observable("");
    Name2: KnockoutObservable<string> = ko.observable("");
    Name3: KnockoutObservable<string> = ko.observable("");
    Name4: KnockoutObservable<string> = ko.observable("");
    Name5: KnockoutObservable<string> = ko.observable("");
    Name = ko.pureComputed({
        read: function () {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Name1();
                case 2:
                    return this.Name2();
                case 3:
                    return this.Name3();
                case 4:
                    return this.Name4();
                case 5:
                    return this.Name5();
            }
        },
        write: function (value) {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Name1(value);
                    break;
                case 2:
                    this.Name2(value);
                    break;
                case 3:
                    this.Name3(value);
                    break;
                case 4:
                    this.Name4(value);
                    break;
                case 5:
                    this.Name5(value);
                    break;
            }
        }
    }, this);
    public constructor(tabPage: TabPage) {
        super(tabPage);
    }
    public InitUrl(): string {
        return "LanguageConfigurationItem/Init";
    }
    public CompleteCheck(): JQueryPromise<boolean> | boolean {
        let completed: boolean;
        completed = true;
        if (!this.Name) {
            completed = false;
        }
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    public Translate = function () {
        let translateDialog = new TranslateDialog(this.Name1, this.Name2, this.Name3, this.Name4, this.Name5);
        translateDialog.Open().then(function () { });
    };
    public init(): JQueryPromise<void> {
        return super.init();
    }
}
export default LanguageConfigurationItem;